jQuery.fn.FloatLabel = function( options ){

	var defaults = {
		populatedClass : 'populated',
		focusedClass : 'focused'
	},
		settings = jQuery.extend({}, defaults, options);

	return this.each(function(){

		var element = jQuery(this),
			label = element.find('label'),
			input = element.find('textarea, input, select');

  if( input.val() == '' ) {
	//input.val( label.text() );
  } else {
	element.addClass( settings.populatedClass );
  }

		input.on( 'focus', function(){
			element.addClass( settings.focusedClass );
			
			if( input.val() === label.text() ){
				input.val('');
			} else {
				element.addClass( settings.populatedClass );
			}

		});

		input.on( 'blur', function(){
			element.removeClass( settings.focusedClass );
			
			if( !input.val() ){
				
				element.removeClass( settings.populatedClass );
			}

		});

		input.on( 'keyup', function(){
			element.addClass( settings.populatedClass );
		});

	});

};
function matchStart(params, data) {
	params.term = params.term || '';
	if (data.text.toUpperCase().indexOf(params.term.toUpperCase()) == 0) {
		return data;
	}
	return false;
}
jQuery(document).ready(function($) {
	
	
	
	
	jQuery(document).on('keyup', 'input.select2-search__field', function() {
		  if(jQuery(this).val() == '') {
			  jQuery(this).parents('.select2-dropdown').removeClass('searching');
		  } else {
			  jQuery(this).parents('.select2-dropdown').addClass('searching');
		  }
	});
	if(jQuery('.community-start').length) {
		var startdate = datepicker('.community-start', {
			id: 1,
			onSelect: instance => {

				jQuery('.community-start').focus();
			},
			formatter: (input, date, instance) => {
				const value = date.toLocaleDateString('en-US');
				input.value = value; // => '1/1/2099'
			}
		});
	}
	
	if (jQuery('.community-end').length) {
		var enddate = datepicker('.community-end', { 
			id: 1,
			onSelect: instance => {
				jQuery('.community-end').focus();
			},
			formatter: (input, date, instance) => {
				const value = date.toLocaleDateString('en-US');
				input.value = value; // => '1/1/2099'
			} 
		});
	}
	
	
});

function setup_fod_form() {
	
	jQuery( '.signup-fod .field-group' ).FloatLabel();
	jQuery('.fod-select').select2({
		dropdownPosition: 'below',
		matcher: matchStart,
		minimumResultsForSearch: 20
	});
	jQuery('.fod-select').on("select2:select", function (e) { 
		var $this = jQuery(this);
		$this.parents('.field-group').addClass('populated');	
		mc_validate_element($this[0]);
		
		if($this.hasClass('conditional-select')) {
			var $other_container = $this.parents('.conditional-fields').find('.other-category');
			var $other_input = $other_container.find('input');
			if($this.val() == 'Other (please specify)') {
				$other_container.addClass('visible');
				$other_input.addClass('fod-required');
			} else {
				$other_container.removeClass('visible');
				$other_input.removeClass('fod-required');
				$other_input.val('');
			}
		}
	});
	jQuery('.fod-select').on('select2:open', function(e) {
		jQuery('input.select2-search__field').prop('placeholder', 'Search');
	});
	jQuery('.fod-select').on('select2:close', function(e) {
		mc_validate_element(jQuery(this)[0]);
	});
	jQuery("input.all-news").change(function () {
		
		if(jQuery(this).prop('checked')) {
			
			jQuery(".interestgroup_field input:not(.all-news)").prop('checked', false);
			jQuery(this).parents('.field-group').removeClass('has-error');
		}	
	});
	jQuery(".interestgroup_field input:not(.all-news)").change(function () {
		if(jQuery(this).prop('checked')) {
			jQuery(".interestgroup_field input.all-news").prop('checked', false);
			jQuery(this).parents('.field-group').removeClass('has-error');
		}	
	});
}

jQuery(window).load(function() {
	setup_fod_form();	
});
var doit;
window.onresize = function(){
  clearTimeout(doit);
  doit = setTimeout(setup_fod_form, 100);
};

